import React from "react";
import PropTypes from "prop-types";
import Chip from "@material-ui/core/Chip";

export default function AssetStatusChips({ asset, assetTypeLabel }) {
  if (!asset) {
    return null;
  }

  return (
    <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginTop: 8 }}>
      <Chip
        label={asset.active ? "Active" : "Inactive"}
        style={{
          backgroundColor: asset.active ? "#d1fae5" : "#fee2e2",
          color: "#111827"
        }}
      />
      <Chip
        label={`Type: ${assetTypeLabel || "Unknown"}`}
        style={{ backgroundColor: "#dbeafe", color: "#1e3a8a" }}
      />
      <Chip
        label={asset.code ? `Code: ${asset.code}` : "No Code"}
        style={{ backgroundColor: "#f3f4f6", color: "#374151" }}
      />
    </div>
  );
}

AssetStatusChips.propTypes = {
  asset: PropTypes.object,
  assetTypeLabel: PropTypes.string
};
